module.exports = __webpack_public_path__ + "static/portal-f2d4b4812515aa108f33da1d0dfa471b.png";